import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { ErrorModal } from '../components/UIkit/modal/ErrorModal'
import { AUTH_ERROR, NO_USER_DATA } from '../constants/errors'
import LoginButton from '../components/UIkit/LoginButton'
import { signIn } from '../reducks/users/operations'
import { useMobile } from '../hooks/useMobile'

// Importing assets - you'll need to update these paths to match your actual assets
import logo from '../assets/img/icons/login_logo.svg'

const SignIn = () => {
  const dispatch = useDispatch()
  const { isMobile } = useMobile()
  const [isShowDialog, setIsShowDialog] = useState(false)
  const [message, setMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleSignIn = async () => {
    try {
      setIsLoading(true)
      const result = await dispatch(signIn(isMobile))
      if (result === NO_USER_DATA) {
        setIsShowDialog(true)
        setMessage('ユーザが登録されていません')
      } else if (result === AUTH_ERROR) {
        setIsShowDialog(true)
        setMessage('メールアカウントが取得できません')
      } else {
        setIsShowDialog(false)
        setMessage('')
      }
    } catch (error) {
      console.error('Sign-in error:', error)
      setIsShowDialog(true)
      setMessage('サインインに失敗しました')
    } finally {
      setIsLoading(false)
    }
  }

  const currentYear = new Date().getFullYear()

  return (
    <div className="signin-wrapper">
      <div className="signin-container">
        <div className="background-decoration"></div>
        <div className="background-decoration-2"></div>

        <div className="signin-card">
          <div className="logo-section">
            <img src={logo} alt="MorimaTecthWare" className="logo-image" />
          </div>

          <div className="content-section">
            <div className="app-title">
              <h1>MorimaTecthWare</h1>
              <p>制服注文管理アプリケーション</p>
            </div>

            <LoginButton
              label={isLoading ? '接続中...' : 'アプリをはじめる'}
              onClick={handleSignIn}
              disabled={isLoading}
            />
          </div>
        </div>

        <footer className="signin-footer">
          <div className="footer-links">
            <a
              href="https://www.morimatsu.jp/"
              target="_blank"
              rel="noreferrer noopener"
            >
              運営会社
            </a>
            <a href="/" target="_blank" rel="noreferrer noopener">
              利用規約
            </a>
            <a href="/" target="_blank" rel="noreferrer noopener">
              プライバシーポリシー
            </a>
          </div>

          <div className="footer-info">
            {/* <p>Copyright &copy; {currentYear} MORIMATSU INDUSTRY CO.,LTD</p> */}
            <p>Copyright &copy; 2024 MORIMATSU INDUSTRY CO.,LTD</p>
            <p className="developer-credit">
              Developed by{' '}
              <a
                href="https://tech-forest.vercel.app/"
                target="_blank"
                rel="noreferrer noopener"
              >
                S.HCodeLv
              </a>
            </p>
          </div>
        </footer>
      </div>

      {isShowDialog && (
        <ErrorModal
          title={'ログインエラー'}
          message={message}
          setIsShow={setIsShowDialog}
        />
      )}

      {/* Styles */}
      <style jsx>{`
        .signin-wrapper {
          display: flex;
          margin-top: -96px;
          padding-top: 96px;
          height: calc(100vh);
          width: 100%;
          background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
          position: relative;
          overflow: hidden;
        }

        .signin-container {
          display: flex;
          flex-direction: column;
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          padding: 2rem;
          position: relative;
          z-index: 1;
        }

        .background-decoration {
          position: absolute;
          top: -150px;
          right: -150px;
          width: 400px;
          height: 400px;
          border-radius: 50%;
          background: linear-gradient(
            135deg,
            rgba(77, 208, 225, 0.4) 0%,
            rgba(38, 198, 218, 0.2) 100%
          );
          z-index: -1;
          animation: float 20s ease-in-out infinite alternate;
        }

        .background-decoration-2 {
          position: absolute;
          bottom: -200px;
          left: -100px;
          width: 500px;
          height: 500px;
          border-radius: 50%;
          background: linear-gradient(
            135deg,
            rgba(255, 213, 79, 0.3) 0%,
            rgba(200, 164, 21, 0.1) 100%
          );
          z-index: -1;
          animation: float 15s ease-in-out infinite alternate-reverse;
        }

        @keyframes float {
          0% {
            transform: translate(0, 0) rotate(0deg);
          }
          50% {
            transform: translate(20px, 20px) rotate(5deg);
          }
          100% {
            transform: translate(-20px, 10px) rotate(-5deg);
          }
        }

        .signin-card {
          display: flex;
          background: white;
          border-radius: 16px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          margin: auto;
          width: 90%;
          max-width: 900px;
          min-height: 400px;
          position: relative;
          animation: fadeIn 0.6s ease-out;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .signin-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 5px;
          background: linear-gradient(90deg, #4dd0e1, #ffd54f);
        }

        .logo-section {
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 2rem;
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        }

        .logo-image {
          max-width: 100%;
          max-height: 250px;
          transition: transform 0.3s ease;
        }

        .logo-image:hover {
          transform: scale(1.03);
        }

        .content-section {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 3rem 2rem;
          position: relative;
        }

        .content-section::before {
          content: '';
          position: absolute;
          left: 0;
          top: 10%;
          height: 80%;
          width: 1px;
          background: linear-gradient(
            to bottom,
            transparent,
            #e0e0e0,
            transparent
          );
        }

        .app-title {
          margin-bottom: 3rem;
        }

        .app-title h1 {
          font-size: 2.2rem;
          font-weight: 600;
          margin: 0;
          background: linear-gradient(90deg, #4dd0e1, #26c6da);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          letter-spacing: -0.5px;
        }

        .app-title p {
          margin-top: 0.5rem;
          font-size: 1rem;
          color: #6c757d;
        }

        .signin-footer {
          margin-top: auto;
          padding-top: 2rem;
          text-align: center;
        }

        .footer-links {
          display: flex;
          justify-content: center;
          gap: 1.5rem;
          margin-bottom: 1rem;
        }

        .footer-links a {
          color: #495057;
          text-decoration: none;
          font-size: 0.9rem;
          transition: color 0.2s ease;
        }

        .footer-links a:hover {
          color: #4dd0e1;
        }

        .footer-info {
          font-size: 0.85rem;
          color: #6c757d;
          line-height: 1.5;
        }

        .developer-credit {
          font-size: 0.75rem;
          color: #adb5bd;
          margin-top: 0.3rem;
        }

        .developer-credit a {
          color: #4dd0e1;
          text-decoration: none;
        }

        .developer-credit a:hover {
          text-decoration: underline;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .signin-card {
            flex-direction: column;
          }

          .content-section::before {
            display: none;
          }

          .content-section {
            padding: 2rem;
          }

          .logo-section {
            padding: 1.5rem;
          }

          .logo-image {
            max-height: 150px;
          }

          .app-title h1 {
            font-size: 1.8rem;
          }

          .footer-links {
            flex-direction: column;
            gap: 0.5rem;
          }
        }

        @media (max-width: 480px) {
          .signin-container {
            padding: 1rem;
          }

          .signin-card {
            width: 95%;
          }

          .app-title h1 {
            font-size: 1.5rem;
          }

          .app-title p {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  )
}

export default SignIn
